import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Building2, Users } from 'lucide-react';
import PageLayout from './PageLayout';
import { useIsMobile } from '../ui';

const NAV_ITEMS = [
  { path: '/admin', label: 'Overview', Icon: LayoutDashboard, exact: true },
  { path: '/admin/organizations', label: 'Organizations', Icon: Building2 },
  { path: '/admin/users', label: 'Users', Icon: Users },
];

export default function AdminLayout({ children }) {
  const location = useLocation();
  const isMobile = useIsMobile();

  const isActive = (item) => item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path);

  // Admin tables (users, organizations) need the full shell width — the 200px
  // side nav would otherwise leave them ~736px.
  return (
    <PageLayout wide>
      <div style={{ display: 'flex', gap: '24px', flexDirection: isMobile ? 'column' : 'row', alignItems: 'flex-start' }}>
        <nav style={{
          width: isMobile ? '100%' : '200px', flexShrink: 0,
          display: 'flex', flexDirection: isMobile ? 'row' : 'column', gap: '2px',
          overflowX: isMobile ? 'auto' : 'visible',
        }}>
          {NAV_ITEMS.map(item => {
            const active = isActive(item);
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex', alignItems: 'center', gap: '9px',
                  padding: '9px 12px', borderRadius: '8px', fontSize: '13.5px', fontWeight: 600,
                  textDecoration: 'none', whiteSpace: 'nowrap',
                  color: active ? 'var(--red-dark)' : 'var(--gray-600)',
                  background: active ? 'var(--red-light)' : 'transparent',
                  transition: 'background 0.15s, color 0.15s',
                }}
              >
                <item.Icon size={16} />
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div style={{ flex: 1, minWidth: 0, width: '100%' }}>{children}</div>
      </div>
    </PageLayout>
  );
}
